import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { track } from '@amplitude/analytics-browser';
import { useSelector } from 'react-redux';

// Components
import MainBanner from '../../components/common/MainBanner';
import FilmsSliderLazyContainer from '../../containers/FilmsSliderLazyContainer';
import ChannelSliderLazyContainer from '../../containers/ChannelSliderLazyContainer';
import UserRecommendedVideosContainer from '../../containers/UserRecommendedVideosContainer';
import TvContentSliderLazyContainer from '../../containers/TvContentSliderLazyContainer';
import LoginForm from '../../components/forms/LoginForm';
import {
  fetchNewestCartoons,
  fetchNewestMovies,
  fetchNewestSeries,
  fetchPremieresCollection,
  getNewestCartoons,
  getNewestMovies,
  getNewestSeries,
  getNewestShow,
  getPremieresCollection,
  fetchNewestShows
} from '../../../features/video-collections/videoCollectionsSlice';
import {
  fetchMoviesChannelsListPopular,
  getChannelsListPopular
} from '../../../features/channels-collections/channelsCollectionsSlice';
import { getTvCaregories } from '../../../features/video-configuration/videoConfigurationSlice';
import {
  SERIES_CATEGORY_NUMBER,
  MOVIES_CATEGORY_NUMBER,
  CARTOONS_CATEGORY_NUMBER,
  SHOWS_CATEGORY_NUMBER
} from '../../constants/configuration';
import { buildSearchParams } from '../../helpers/utils';
import { IS_SHOW_TV_CONTENT } from '../../constants/configuration';

const Home = () => {
  const { t, i18n } = useTranslation();
  const { popupAuthorization } = useParams();
  const tvCategories = useSelector(getTvCaregories);

  useEffect(() => {
    track('Main Page Viewed');
  }, []);

  const showPopupAuthorization = () => {
    switch (popupAuthorization) {
      case 'login':
        return <LoginForm />;
    }
  };

  return (
    <>
      {popupAuthorization && showPopupAuthorization()}
      <MainBanner />
      <ChannelSliderLazyContainer
        selector={getChannelsListPopular}
        getContentAsync={fetchMoviesChannelsListPopular}
        title={t('titles.channels')}
      />

      {/*
      {IS_SHOW_TV_CONTENT ? (
        <TvContentSliderLazyContainer
          genreId={'kinohity'}
          title={
            tvCategories.find((i) => i.id === 'kinohity')?.title_localized[i18n.language] || ''
          }
        />
      ) : null} */}

      {IS_SHOW_TV_CONTENT ? (
        <TvContentSliderLazyContainer
          genreId={'boyovyky'}
          title={
            tvCategories.find((i) => i.id === 'boyovyky')?.title_localized[i18n.language] || ''
          }
        />
      ) : null}

      {IS_SHOW_TV_CONTENT ? (
        <TvContentSliderLazyContainer
          genreId={'komedii'}
          title={tvCategories.find((i) => i.id === 'komedii')?.title_localized[i18n.language] || ''}
        />
      ) : null}

      {IS_SHOW_TV_CONTENT ? (
        <TvContentSliderLazyContainer
          genreId={'dramy'}
          title={tvCategories.find((i) => i.id === 'dramy')?.title_localized[i18n.language] || ''}
        />
      ) : null}

      {IS_SHOW_TV_CONTENT ? (
        <TvContentSliderLazyContainer
          genreId={'dokumentalni'}
          title={
            tvCategories.find((i) => i.id === 'dokumentalni')?.title_localized[i18n.language] || ''
          }
        />
      ) : null}

      {IS_SHOW_TV_CONTENT ? (
        <TvContentSliderLazyContainer
          genreId={'istorychni'}
          title={
            tvCategories.find((i) => i.id === 'istorychni')?.title_localized[i18n.language] || ''
          }
        />
      ) : null}

      {IS_SHOW_TV_CONTENT ? (
        <TvContentSliderLazyContainer
          genreId={'filmy-na-tb'}
          title={
            tvCategories.find((i) => i.id === 'filmy-na-tb')?.title_localized[i18n.language] || ''
          }
        />
      ) : null}

      {IS_SHOW_TV_CONTENT ? (
        <TvContentSliderLazyContainer
          genreId={'serialy-na-tb'}
          title={
            tvCategories.find((i) => i.id === 'serialy-na-tb')?.title_localized[i18n.language] || ''
          }
        />
      ) : null}

      <FilmsSliderLazyContainer
        selector={getPremieresCollection}
        getContentAsync={fetchPremieresCollection}
        title={t('homePage.titles.premieres')}
        headingHref="/premieres"
      />

      <FilmsSliderLazyContainer
        selector={getNewestMovies}
        getContentAsync={fetchNewestMovies}
        title={t('homePage.titles.movies')}
        headingHref={`/newest-movies/?${buildSearchParams(
          MOVIES_CATEGORY_NUMBER,
          'year',
          null,
          null,
          null,
          null,
          1
        )}`}
      />

      <FilmsSliderLazyContainer
        selector={getNewestSeries}
        getContentAsync={fetchNewestSeries}
        title={t('homePage.titles.series')}
        headingHref={`/newest-series/?${buildSearchParams(
          SERIES_CATEGORY_NUMBER,
          'year',
          null,
          null,
          null,
          null,
          1
        )}`}
      />

      <FilmsSliderLazyContainer
        selector={getNewestCartoons}
        getContentAsync={fetchNewestCartoons}
        title={t('homePage.titles.cartoons')}
        headingHref={`/newest-cartoons/?${buildSearchParams(
          CARTOONS_CATEGORY_NUMBER,
          'year',
          null,
          null,
          null,
          null,
          1
        )}`}
      />

      <FilmsSliderLazyContainer
        selector={getNewestShow}
        getContentAsync={fetchNewestShows}
        title={t('homePage.titles.show')}
        headingHref={`/newest-show/?${buildSearchParams(
          SHOWS_CATEGORY_NUMBER,
          'year',
          null,
          null,
          null,
          null,
          1
        )}`}
      />
      <UserRecommendedVideosContainer
        recommendedListHeading={t('homePage.titles.recommended')}
        isSlider={true}
        limit={20}
      />
    </>
  );
};

export default Home;
